import { render, staticRenderFns } from "./DynamicInputs.vue?vue&type=template&id=975dbc7a&scoped=true&"
import script from "./DynamicInputs.vue?vue&type=script&lang=ts&"
export * from "./DynamicInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975dbc7a",
  null
  
)

export default component.exports